import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
interface SparkleProps {
  className?: string;
  /** Seconds for one slow drift cycle. */
  drift?: number;
  delay?: number;
  color?: string;
}

/** A small golden four-point sparkle that drifts very slowly. Decorative. */
export function Sparkle({
  className = 'h-5 w-5',
  drift = 7,
  delay = 0,
  color = '#FFC53D'
}: SparkleProps) {
  const reduceMotion = useReducedMotion();
  return <motion.svg viewBox="0 0 24 24" aria-hidden="true" focusable="false" className={`pointer-events-none ${className}`} animate={reduceMotion ? undefined : {
    y: [0, -10, 0],
    scale: [1, 1.12, 1],
    rotate: [0, 10, 0]
  }} transition={reduceMotion ? undefined : {
    duration: drift * 0.35,
    delay: delay * 0.5,
    repeat: Infinity,
    ease: 'easeInOut'
  }} data-id="element-309" data-mp="os5u6u5p3rbr">
      <path d="M12 1.5C12.9 8 16 11.1 22.5 12C16 12.9 12.9 16 12 22.5C11.1 16 8 12.9 1.5 12C8 11.1 11.1 8 12 1.5Z" fill={color} stroke="#1E1B39" strokeWidth="1.2" strokeLinejoin="round" data-id="element-310" data-mp="2a736u26s7it4" />
    </motion.svg>;
}